/**
 * Zoom controls for tree view
 */

import React from 'react';
import { motion } from 'framer-motion';
import { ZoomIn, ZoomOut } from 'lucide-react';

export interface ZoomControlsProps {
  zoomLevel: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
  canZoomIn: boolean;
  canZoomOut: boolean;
}

export const ZoomControls: React.FC<ZoomControlsProps> = ({
  zoomLevel,
  onZoomIn,
  onZoomOut,
  onReset,
  canZoomIn,
  canZoomOut
}) => (
  <div className="fixed bottom-4 left-4 z-40 flex flex-col gap-1.5 rounded-xl border border-slate-200/90 bg-white/95 p-1.5 shadow-lg backdrop-blur-sm">
    <motion.button
      whileHover={{ scale: 1.04 }}
      whileTap={{ scale: 0.96 }}
      onClick={onZoomIn}
      disabled={!canZoomIn}
      className="w-10 h-10 bg-slate-50 rounded-lg border border-slate-200/80 flex items-center justify-center text-slate-800 hover:bg-white hover:border-slate-300 disabled:opacity-45 disabled:cursor-not-allowed transition-colors"
      title="Zoom In"
    >
      <ZoomIn size={18} strokeWidth={2} />
    </motion.button>
    <div className="w-10 min-h-[2.25rem] px-1 bg-slate-900 text-white rounded-lg flex items-center justify-center text-[11px] font-semibold tabular-nums tracking-tight">
      {Math.round(zoomLevel * 100)}%
    </div>
    <motion.button
      whileHover={{ scale: 1.04 }}
      whileTap={{ scale: 0.96 }}
      onClick={onZoomOut}
      disabled={!canZoomOut}
      className="w-10 h-10 bg-slate-50 rounded-lg border border-slate-200/80 flex items-center justify-center text-slate-800 hover:bg-white hover:border-slate-300 disabled:opacity-45 disabled:cursor-not-allowed transition-colors"
      title="Zoom Out"
    >
      <ZoomOut size={18} strokeWidth={2} />
    </motion.button>
    <motion.button
      whileHover={{ scale: 1.04 }}
      whileTap={{ scale: 0.96 }}
      onClick={onReset}
      className="w-10 h-9 bg-white rounded-lg border border-slate-200 text-[10px] font-semibold text-slate-700 hover:bg-slate-50 transition-colors tracking-tight"
      title="Reset Zoom"
    >
      Reset
    </motion.button>
  </div>
);
